import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { interceptorFn } from './services/interceptor/interceptor.service';
import { loaderInterceptorFn } from './services/interceptor/loader.interceptor';
// import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
// import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([interceptorFn, loaderInterceptorFn])),
    // {
    //   provide: RECAPTCHA_V3_SITE_KEY,
    //   useValue: environment.google_recaptcha_site_key
    // }
  ],
};
